<template>
  <div class="ai-float-btn-wrapper">
    <!-- 脉冲波纹 -->
    <div class="pulse-ring"></div>
    <div class="pulse-ring delay"></div>
    
    <!-- 主按钮 -->
    <div class="ai-assistant-float-btn" @click="handleShowAIAssistant" title="智能助手">
      <div class="btn-content">
        <img src="@/assets/myImg/1/合汇LOGO-渐变.svg" class="float-logo" alt="AI" />
      </div>
    </div>
    
    <!-- 悬停提示 -->
    <div class="float-tooltip">
      <span>智能助手</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIAssistantFloatBtn',
  methods: {
    handleShowAIAssistant() {
      this.$root.$emit('show-ai-assistant')
    }
  }
}
</script>

<style lang="less" scoped>
.ai-float-btn-wrapper {
  position: fixed;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    .float-tooltip {
      opacity: 1;
      transform: translateX(-10px);
    }
    
    .pulse-ring {
      animation-play-state: paused;
    }
  }
}

.ai-assistant-float-btn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(230, 247, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(24, 144, 255, 0.4);
  box-shadow: 0 0 15px rgba(24, 144, 255, 0.3), inset 0 0 10px rgba(24, 144, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 2;
  
  .btn-content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    overflow: hidden;
    
    .float-logo {
      width: 32px;
      height: 32px;
      object-fit: contain;
      transition: all 0.5s;
    }
  }
  
  &:hover {
    transform: scale(1.1);
    background: rgba(230, 247, 255, 0.95);
    border-color: #1890ff;
    box-shadow: 0 0 25px rgba(24, 144, 255, 0.5), inset 0 0 15px rgba(24, 144, 255, 0.3);
    
    .float-logo {
      transform: rotate(360deg) scale(1.1);
    }
  }
  
  &:active {
    transform: scale(0.95);
  }
}

.pulse-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #1890ff;
  opacity: 0;
  animation: pulse 3s infinite cubic-bezier(0.455, 0.03, 0.515, 0.955);
  z-index: 1;
  pointer-events: none;
  
  &.delay {
    animation-delay: 1.5s;
  }
}

.float-tooltip {
  position: absolute;
  right: 100%;
  background: rgba(230, 247, 255, 0.9);
  backdrop-filter: blur(8px);
  padding: 6px 12px;
  border-radius: 6px;
  color: #1890ff;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  transform: translateX(0);
  transition: all 0.3s;
  pointer-events: none;
  border: 1px solid rgba(24, 144, 255, 0.2);
  margin-right: 12px;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.15);
  
  &::after {
    content: '';
    position: absolute;
    right: -4px;
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    width: 8px;
    height: 8px;
    background: inherit;
    border-right: 1px solid rgba(24, 144, 255, 0.2);
    border-top: 1px solid rgba(24, 144, 255, 0.2);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  100% {
    transform: scale(2.2);
    opacity: 0;
  }
}
</style>

